export default {
  pagination: {},
  quizzes: []
};
